import { useGetHeightTable } from 'app/hook'
import { useTableHook } from './hook'
import { TableWrapper } from './styles'

export const LocationWithOrthodonticAppointment = () => {
  const { columns, tableData, handleTableChange} = useTableHook()
  return (
    <TableWrapper
      columns={columns}
      dataSource={tableData.data}
      loading={tableData.loading}
      pagination={tableData.pagination}
      onChange={handleTableChange}
      scroll={{
        x: true,
        y: tableData.data?.length ? useGetHeightTable(283, 0) : undefined,
      }}
    />
  )
}
